import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { promotoresApi } from '@/data/api/promotoresApi';
const KEY = 'promotores-admin';
const COMISIONES_KEY = 'comisiones-sucursal';
export function usePromotoresLista(filtros) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => promotoresApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function usePromotor(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => promotoresApi.ver(id),
        enabled: Boolean(id),
    });
}
export function useCrearPromotor() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => promotoresApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useEditarPromotor() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => promotoresApi.editar(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useDesactivarPromotor() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => promotoresApi.desactivar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useComisionSucursal(sucursalId) {
    return useQuery({
        queryKey: [COMISIONES_KEY, sucursalId],
        queryFn: () => promotoresApi.verComisionSucursal(sucursalId),
        enabled: Boolean(sucursalId),
        staleTime: 60_000,
    });
}
export function useUpsertComisionSucursal(sucursalId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => promotoresApi.upsertComisionSucursal(sucursalId, v),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: [COMISIONES_KEY, sucursalId] });
        },
    });
}
